import { Component, OnInit, ViewChild } from '@angular/core';
import { SystemService, SystemSourceService, SystemEstimationLevelService, DateTemplateService, SystemStatusService, ContactService, ProductionSourceService, ProjectService, SourceService, SystemByProgramService, SystemAllocationStatusService } from '../../../camtl.service';

import { System } from '../../../../../shared/model';
import { ZoneService, ModelYearService, ProgramService, TitleService, SubZoneTitleService } from '../../../../mesc/mesc.service';
import { Validators, FormBuilder } from '@angular/forms';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { BehaviorSubject } from 'rxjs';
import { parseDate } from '@progress/kendo-angular-intl';

@Component({
    selector: 'mesc-systems',
    templateUrl: './systems.component.html',
    // styleUrls: ['./systems.component.scss']
})
export class CamtlSystemsComponent implements OnInit {

    constructor(
        private service: SystemService,
        private ZoneService: ZoneService,
        private ProjectService: ProjectService,
        private SystemByProgramService: SystemByProgramService,
        private ModelYearService: ModelYearService,
        private SystemSourceService: SystemSourceService,
        private TitleService: TitleService,
        private ContactService: ContactService,
        private SystemEstimationLevelService: SystemEstimationLevelService,
        private DateTemplateService: DateTemplateService,
        private SystemStatusService: SystemStatusService,
        private SourceService: SourceService,
        private productionSourceService: ProductionSourceService,
        private SubZoneTitleService: SubZoneTitleService,
        private FormBuilder: FormBuilder,
        public ProgramService: ProgramService,
        private cgpSnackbarService: CgpSnackbarService,
        private cgpAlertDialogService: CgpAlertDialogService,
        private allocationStatusService: SystemAllocationStatusService
    ) { }

    @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
    isNew: boolean = false;
    editDataItem: System;
    SelectedProgram: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
    system = {};
    Programs: Array<System>;

    ngOnInit(): void {
        this.ZoneService.query();
        this.ProjectService.read("?$filter=Active eq true", true)
            .then((response) => {
                response.map(x => x.ConcatNumberDesc = x.ProjectNumber + " - " + x.Description)
                this.ProjectService.data = response;
                return response;
            });
        this.ModelYearService.query();
        this.allocationStatusService.query();
        this.ProgramService.query("?$filter=IsActive eq true");
        this.TitleService.query();
        this.ContactService.query('/role/ME');
        this.SystemSourceService.query();
        this.SystemEstimationLevelService.query();
        this.DateTemplateService.query();
        this.SystemStatusService.query();
        this.SourceService.read("?$filter=SourceTypeName eq 'Mech Design'", true);
        this.productionSourceService.read("?$filter=SourceTypeName eq 'Production'", true);
        this.SubZoneTitleService.query("?$filter=IsActive eq true");
    }


    handleRead = () => {
        return this.SelectedProgram.value ?
            this.SystemByProgramService.read("/" + this.SelectedProgram.value.Id + "/system", true).then((response) => {
                try {
                    this.SystemByProgramService.loading.next(false);
                    response.map(x => {
                        x['ConcatNumberDesc'] = x.ProjectNumber + ' - ' + x.ProjectDescription;
                        let status = this.allocationStatusService.data.find((status) => status.Id === x.AllocationStatusId);
                        if (status) x['AllocationStatus'] = status.Description;
                        return x;
                    })
                    return response;
                } catch (e) {
                    console.error(e);
                    return response;
                }
            }) :
            Promise.resolve([]);
    }


    handleSave = (dataItem, isNew) => {
        var self = this;
        if (isNew) {
            dataItem.AllocationStatus = "Preliminary";
            self.allocationStatusService.data.filter(function (status) {
                if (status.Description === "Preliminary") dataItem.AllocationStatusId = status.Id;
            })
        }
        if (dataItem && dataItem.AllocationStatus && dataItem.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
            this.editDataItem = undefined;
            this.cgpAlertDialogService.showAlertDialog({
                title: "System In Process",
                message: "Cannot edit this system because it is currently in the allocation process",
                alert: 'danger',
                closeLabel: 'Close',
            })
            return;
        }
        self.service.save(dataItem, isNew, "", true, false)
            .then(function () {
                self.service.loading.next(false);
                self.grid.refresh(true);
                self.cgpSnackbarService.showSnackbar({
                    message: isNew ? "Record has been created" : "Record has been updated",
                    duration: 2000
                });
            })
            .catch(function (response) {
                self.service.loading.next(false);
                self.cgpAlertDialogService.showAlertDialog({
                    title: 'Error',
                    message: response._body.replace(/"/g, ''),
                    alert: 'danger',
                    closeLabel: 'Close',
                })
            })
    }


    handleValueChange(e: any) {
        this.SelectedProgram.next(e);
        e ?
            this.template.fileName = "systems_" + this.SelectedProgram.value.ProgramCode + ".xlsx" :
            this.template.fileName = undefined;
    }


    handleControlDisabled = (controlName: string) => {
        let isDisabled: boolean = false;
        switch (controlName) {
            case 'excel':
            case 'add':
                isDisabled = this.SelectedProgram.value === undefined;
                break;
            default:
                break;
        }
        return isDisabled;
    }


    setModelHandler(): void {
        this.editDataItem = new System();
        this.editDataItem.ProgramId = this.SelectedProgram.value.Id;
    }


    // Datetime string LOGIC //
    stringToDate(date: string): Date {
        try {
            return date ? parseDate(date) : new Date();
        } catch (e) {
            return new Date();
        }
    }


    dateToString(date: Date): string {
        try {
            return date.toISOString();
        } catch (e) {
            return undefined;
        }
    }


    editForm = this.FormBuilder.group({
        SystemNumber: [],
        SubZoneTitleId: ["", Validators.required],
        ProgramId: ["", Validators.required],
        ModelYearId: ["", Validators.required],
        SystemSourceHourId: ["", Validators.required],
        SystemEstimationLevelId: ["", Validators.required],
        ConstructionHours: ["", Validators.required],
        IntegrationHours: ["", Validators.required],
        DateTemplateId: ["", Validators.required],
        SystemStatusId: ["", Validators.required],
        ProductionSourceId: [],
        DesignSourceId: [],

        AllocationStatusId: [],
        AllocationStatus: [],
        SystemSuffix: [],
        ProjectId: [],
        ProjectDescription: [],
        LidNumber: [],
        ProjectNumber: [],
        ProgramCode: [],
        ZoneDescription: [],
        ToolConstruction: [],
        RobotTestCell: [],
        SystemSurroundSetup: [],
        FullIntegration: [],
        Homeline: [],
        Length: [],
        Width: [],
        Height: [],
        BldQtyLeft: ["", Validators.required],
        BldQtyRight: ["", Validators.required],
        BldQtyS: ["", Validators.required],
        SystemStatus: [],
        Id: [],

        CreatedDate: [],
        CreatedBy: [],
        ModifiedDate: [],
        ModifiedBy: [],

    });

    columns = [{
        field: "SystemNumber",
        title: "SID"
    },
    {
        field: 'ZoneDescription',
        title: 'Zone/Desc/LID',
    },
    {
        field: "SystemSuffix",
        title: "Suffix"
    },
    {
        field: 'ConcatNumberDesc',
        title: 'Project',
    },
    {
        field: 'ModelYear',
        title: 'Model Year',
    },
    {
        field: 'SystemStatus',
        title: 'Status'
    }]

    template = {
        controls: {
            add: true,
            edit: true,
            delete: false,
            excel: true,
            isDisabled: this.handleControlDisabled,
            width: 65
        },
        columns: this.columns,
        view: this.SystemByProgramService,
        service: this.service,
        read: this.handleRead,
        save: this.handleSave,
        fileName: "systems.xlsx"
    }

    formDialog = {
        title: "System",
        tabs: [
            {
                title: "General",
                selected: true,
                columnClass: 'flex-wrap-column col-size-4',
                formControls: [
                    {
                        type: "combobox",
                        readonly: "always",
                        name: "ProgramId",
                        title: "Program*",
                        textField: 'ProgramCode',
                        valueField: 'Id',
                        placeholder: 'Select Program...',
                        service: this.ProgramService,
                    },
                    {
                        type: "combobox",
                        readonly: "never",
                        name: "SubZoneTitleId",
                        title: "Zone/Desc/LID*",
                        textField: 'SubZoneTitleDescription',
                        valueField: 'Id',
                        placeholder: 'Select a Zone/Desc/LID...',
                        service: this.SubZoneTitleService,
                    },
                    {
                        type: "combobox",
                        readonly: "never",
                        name: "SystemStatusId",
                        title: "Status*",
                        textField: 'Description',
                        valueField: 'Id',
                        placeholder: 'Select a Status...',
                        service: this.SystemStatusService,
                    },
                    {
                        type: "combobox",
                        readonly: "never",
                        name: "SystemSourceHourId",
                        title: "System Source Hours*",
                        textField: 'Name',
                        valueField: 'Id',
                        placeholder: 'Select a System Source...',
                        service: this.SystemSourceService,
                    },
                    {
                        type: "combobox",
                        readonly: "never",
                        name: "SystemEstimationLevelId",
                        title: "Estimate Level*",
                        textField: 'Name',
                        valueField: 'Id',
                        placeholder: 'Select a System Estimation lvl...',
                        service: this.SystemEstimationLevelService,
                    },
                    {
                        type: "combobox",
                        name: "ProjectId",
                        title: "Project",
                        textField: 'ConcatNumberDesc',
                        valueField: 'Id',
                        placeholder: 'Select a Project...',
                        service: this.ProjectService,
                        sync: true
                    },
                    {
                        type: "number",
                        name: "ConstructionHours",
                        title: "Construction Hours*",
                        readonly: "never",
                        minimum: "0",
                        maximum: "10000",
                    },
                    {
                        type: "number",
                        name: "IntegrationHours",
                        title: "Integration Hours*",
                        readonly: "never",
                        minimum: "0",
                        maximum: "10000",
                    },
                ],
            },
            {
                title: "Details",
                selected: false,
                columnClass: 'flex-wrap-column col-size-4',
                formControls: [
                    {
                        type: "number",
                        name: "BldQtyLeft",
                        title: "BldQtyLeft*",
                        readonly: "never",
                        minimum: "0",
                        maximum: "1000",
                    },
                    {
                        type: "number",
                        name: "BldQtyRight",
                        title: "BldQtyRight*",
                        readonly: "never",
                        minimum: "0",
                        maximum: "1000",
                    },
                    {
                        type: "number",
                        name: "BldQtyS",
                        title: "BldQtyS*",
                        readonly: "never",
                        minimum: "0",
                        maximum: "1000",
                    },
                    {
                        type: "combobox",
                        readonly: "never",
                        name: "ModelYearId",
                        title: "Year*",
                        textField: 'Year',
                        valueField: 'Id',
                        placeholder: 'Select a Year...',
                        service: this.ModelYearService,
                    },
                    {
                        type: "text",
                        name: "SystemSuffix",
                        title: "Suffix",
                        readonly: "never",
                    },
                    {
                        type: "number",
                        name: "Length",
                        title: "Length",
                        readonly: "never",
                        minimum: "0",
                        maximum: "1000",
                    },
                    {
                        type: "number",
                        name: "Width",
                        title: "Width",
                        readonly: "never",
                        minimum: "0",
                        maximum: "1000",
                    },
                    {
                        type: "number",
                        name: "Height",
                        title: "Height",
                        readonly: "never",
                        minimum: "0",
                        maximum: "1000",
                    },
                    {
                        type: "combobox",
                        readonly: "update",
                        name: "DesignSourceId",
                        title: "Design Source",
                        textField: 'SourceName',
                        valueField: 'Id',
                        placeholder: 'Select a Design Source...',
                        service: this.SourceService,
                    },
                    {
                        type: "combobox",
                        readonly: "update",
                        name: "ProductionSourceId",
                        title: "Production Source",
                        textField: 'SourceName',
                        valueField: 'Id',
                        placeholder: 'Select a Production Source...',
                        service: this.productionSourceService,
                    },
                    {
                        type: "combobox",
                        readonly: "never",
                        name: "DateTemplateId",
                        title: "VDP*",
                        textField: 'TemplateName',
                        valueField: 'Id',
                        placeholder: 'Select a Date Template...',
                        service: this.DateTemplateService,
                    }
                ],
            },

        ]
    }

}
